export default __webpack_public_path__ + "373ea71ed6d655fd60182a9413cfb532.svg";